import * as _accessors from './accessors';
import * as _actions from './actions';
import _reducer from './reducer';
import _CoveredInClass from './model';

export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;
export const CoveredInClass = _CoveredInClass;



// WEBPACK FOOTER //
// ./data/CoveredInClass/index.js